var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.labels),function(label,index){return _c('v-tooltip',{key:index,attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-chip',_vm._g(_vm._b({staticClass:"ma-1",attrs:{"small":"","label":""}},'v-chip',attrs,false),on),[_c('span',{staticClass:"limit-label-characters"},[_vm._v(_vm._s(label))])])]}}],null,true)},[_c('span',[_vm._v(_vm._s(label))])])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }